import React from 'react';

const differences = [
  {
    title: "Three services. One PhantomPath Portal.",
    desc: "Manage VPN access, travel eSIM data and supported virtual-number services through one straightforward Portal."
  },
  {
    title: "Choose only what you need",
    desc: "There is no forced bundle, no automatic renewal and no mandatory traditional VPN account. Buy new access only when you want it."
  },
  {
    title: "Secure payment options",
    desc: "Pay using Stripe, PayPal or supported UK carrier billing where available. Current options are shown clearly before checkout."
  },
  {
    title: "A registered UK company",
    desc: "PhantomPathVPN Ltd publishes its company, ICO registration and customer contact information clearly on this website."
  },
  {
    title: "Privacy-conscious data handling",
    desc: "We collect only the limited information needed to deliver, secure and support each service and to meet applicable obligations."
  },
  {
    title: "Clear policies and customer care",
    desc: "Pricing, service limitations, refunds, privacy information and customer-care routes are published before you buy."
  }
];

const WhyChoose = () => {
  return (
    <section id="why-choose" className="py-10 px-4 md:py-12 bg-[#0a0a0a] relative border-t border-white/5">
      <div className="container mx-auto max-w-6xl">
        <div className="mb-12 grid gap-5 md:mb-14 md:grid-cols-[minmax(0,0.8fr)_minmax(0,1.2fr)] md:items-end md:gap-16">
          <h2 className="w-fit border-b-2 border-white/20 pb-2 text-2xl font-bold tracking-tight text-white md:text-4xl">Why people choose PhantomPath</h2>
          <p className="max-w-2xl text-base leading-relaxed text-gray-400 md:text-lg">
            Straightforward services, clear pricing and practical privacy choices from a registered UK company.
          </p>
        </div>

        <div className="grid auto-rows-fr gap-x-10 gap-y-10 md:grid-cols-2 lg:grid-cols-3 lg:gap-x-12 lg:gap-y-12">
          {differences.map((item) => (
            <article key={item.title} className="flex h-full flex-col border-t border-white/15 pt-5">
              <h3 className="mb-3 min-h-[3.25rem] text-lg font-bold leading-snug text-white">{item.title}</h3>
              <p className="text-sm leading-relaxed text-gray-400">{item.desc}</p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WhyChoose;
